import Image from 'next/image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../../styles/ListView.module.css';
import * as LIB from '../../lib/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/fontawesome-free-regular';

const MusicListing = ({ listData, typeName, typeID }) => {
    const clockIcon = <FontAwesomeIcon icon={faClock} />;

    const renderCardContent = (article) => {
        let url = 'javascript:void(0)';
        if (article.id) url = LIB.getBasepath(`/posts/${article.id}/` + encodeURIComponent(article.title.replace(/ /g, '')));
        return (
            <a href={url} target='_blank'>
                <div className={styles.card}>
                    <div className={styles.imgHolder}>
                        {
                            article.thumbnail && <Image
                                src={article.thumbnail}
                                alt="圖片"
                                sizes="100vw"
                                height={220}
                                width={400}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                }}
                            />
                        }
                    </div>
                    <Container fluid>
                        <Row>
                            <Col className={styles.titleColum}>
                                <div className={styles.bottomArea}>
                                    <div className={styles.title}>{article.title}</div>
                                    <div className={styles.excerpt}>{article.excerpt}</div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} className='d-block d-sm-none'>
                                <div className={styles.divider}></div>
                            </Col>
                        </Row>

                        <Row className={styles.infoRow}>
                            <Col className={styles.fullColum}>
                                <div className={styles.date}>{article.post_date.substring(0, 10)}</div>
                            </Col>
                            <Col className={styles.fullColum}>
                                <div className={styles.category}>{article.topic_title ? article.topic_title : '精選推介'}</div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </a>
        );
    };

    if (listData) {
        return (
            <Container fluid style={{ padding: 0 }}>
                <Row style={{ padding: 0, margin: 0 }}>
                    {listData && listData.map((article, index) => (
                        <Col key={index} xs={12} md={6} lg={4} className={styles.colum2}>
                            {renderCardContent(article)}
                        </Col>
                    ))
                    }
                </Row>
            </Container>
        );
    }

    return (<></>);

}

export default MusicListing;